import { throttle } from 'lodash-es';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import toClass from 'recompose/toClass';
import { scroll } from '../actionCreators';
import ScrollableArea from '../components/ScrollableArea';
import { CURRENT_OVERLAY_ID, OVERLAY_LAYER } from '../constants/userTest';
import { isRecording } from '../selectors';
import { getScreenStyles } from '../selectors/layout';
import { getRenderedScreenDimensions, getScreen } from '../selectors/screen';
function mapStateToProps(state, _a) {
    var screenID = _a.screenID, width = _a.width, height = _a.height, isCurrentScreen = _a.isCurrentScreen;
    var screenStyles = getScreenStyles(state, isCurrentScreen, getScreen(state, screenID), width, height);
    var theHeight = getRenderedScreenDimensions(state).height;
    return {
        // constrain height to the viewport to allow contents to scroll but if viewport is greater than
        // overlay constrain it to the max height of the overlay so we don't oversize it
        height: Math.min(height, theHeight),
        width: screenStyles.scrollableAreaWidth,
        padding: screenStyles.scrollableAreaPadding,
        isScrollable: screenStyles.isScrollableAreaScrollable,
        isMobile: state.deviceDetection.isMobile,
        isIOS: state.deviceDetection.isIPad || state.deviceDetection.isIPhone,
        id: CURRENT_OVERLAY_ID,
        isRecording: isRecording(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        // if ownProps is used this needs to be hoisted out of here as it will be recreated every time
        // a prop changes
        onScroll: throttle(function (scrollLeft, scrollTop, screenID) {
            return dispatch(scroll(OVERLAY_LAYER, scrollLeft, scrollTop, screenID));
        }, 50),
    };
}
export default compose(toClass, connect(mapStateToProps, mapDispatchToProps))(ScrollableArea);
